/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Description_Updated_ToastInputs */

const en_explorer_info_description_updated_toast = /** @type {(inputs: Explorer_Info_Description_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description updated`)
};

const fr_explorer_info_description_updated_toast = /** @type {(inputs: Explorer_Info_Description_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description updated`)
};

const de_explorer_info_description_updated_toast = /** @type {(inputs: Explorer_Info_Description_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description updated`)
};

const it_explorer_info_description_updated_toast = /** @type {(inputs: Explorer_Info_Description_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description updated`)
};

const ru_explorer_info_description_updated_toast = /** @type {(inputs: Explorer_Info_Description_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description updated`)
};

const es_explorer_info_description_updated_toast = /** @type {(inputs: Explorer_Info_Description_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description updated`)
};

const zh_cn2_explorer_info_description_updated_toast = /** @type {(inputs: Explorer_Info_Description_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description updated`)
};

const ja_explorer_info_description_updated_toast = /** @type {(inputs: Explorer_Info_Description_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description updated`)
};

const hi_explorer_info_description_updated_toast = /** @type {(inputs: Explorer_Info_Description_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description updated`)
};

const pt_pt2_explorer_info_description_updated_toast = /** @type {(inputs: Explorer_Info_Description_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description updated`)
};

/**
* | output |
* | --- |
* | "Description updated" |
*
* @param {Explorer_Info_Description_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_description_updated_toast = /** @type {((inputs?: Explorer_Info_Description_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Description_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_description_updated_toast(inputs)
	if (locale === "de") return de_explorer_info_description_updated_toast(inputs)
	if (locale === "it") return it_explorer_info_description_updated_toast(inputs)
	if (locale === "ru") return ru_explorer_info_description_updated_toast(inputs)
	if (locale === "es") return es_explorer_info_description_updated_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_description_updated_toast(inputs)
	if (locale === "ja") return ja_explorer_info_description_updated_toast(inputs)
	if (locale === "hi") return hi_explorer_info_description_updated_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_description_updated_toast(inputs)
	return en_explorer_info_description_updated_toast(inputs)
});